import { Injectable } from '@angular/core';
import { CreateMessageService } from './create-message.service';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MakesResolverService implements Resolve<any> {

    constructor(
        private dataService: CreateMessageService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.dataService.getMakesListObservable();
    }
}
